const ADULT_PER_DAY = 50
const CHILDREN_PER_DAY = 25

const calculateStayConst = (formFileds) => {
  if (!formFileds || !formFileds.checkInDate || !formFileds.checkOutDate || !formFileds.adults) {
    return 130
  }
  const checkIn = (new Date(formFileds.checkInDate.year, formFileds.checkInDate.month - 1, formFileds.checkInDate.day))
  const checkOut = (new Date(formFileds.checkOutDate.year, formFileds.checkOutDate.month - 1, formFileds.checkOutDate.day))
  const DifferenceInTime = checkOut.getTime() - checkIn.getTime()
  const DifferenceInDays = (DifferenceInTime / (1000 * 3600 * 24))
  const adultsCost = DifferenceInDays * formFileds.adults.value * ADULT_PER_DAY
  const childrensCost = formFileds.children ? DifferenceInDays * formFileds.children.value * CHILDREN_PER_DAY : 0
  return ((childrensCost + adultsCost + (100 * DifferenceInDays)) > 130) ? (childrensCost + adultsCost + (100 * DifferenceInDays)) : 130
}

export default calculateStayConst
